import React from "react";
import Modal from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Link from "@amzn/meridian/link";
import { useAccessContext } from "src/context/AuthenticationContext";

const TEAM_LINK = "https://permissions.amazon.com/a/team/eagleeye-access-team";

export const AccessBlockedOverlay = () => {
    const hasAccess = useAccessContext();

    if (hasAccess !== false) return null;

    return (
        <Modal open={true} scrollContainer="modal">
            <Column spacing="small">
                <Text type="h300" color="error">
                    You don't have access to EagleEye, your manager can help.
                </Text>
                <Text tag="h4">Here are the steps:</Text>
                <Text>
                    <strong>Step 1:</strong> Your manager needs to add you to{" "}
                    <Link href={TEAM_LINK} target="_blank">{TEAM_LINK}</Link>
                </Text>
                <Text>
                    <strong>Step 2:</strong> Once you are added, wait for 5 minutes and refresh this page.
                </Text>
                <Text type="b200" color="secondary">
                    Note: Access can only be granted by your manager. Please contact them directly with the link above.
                </Text>
            </Column>
        </Modal>
    );
};
